module.exports = __webpack_public_path__ + "assets/img/index-project2-3.466864f8.jpg";